import { TASKS_CREATE_GATE } from './constants';
export function extractWordAfterCreate(str) {
  const match = str.match(/^create(\w+)/);
  return match ? match[1].toLowerCase() : null;
}
export function getNavObjBuilderMenuFrom(menuItems, portalGates) {
  const items = menuItems.filter(item => {
    if (item.id === 'createTask') {
      return portalGates.includes(TASKS_CREATE_GATE);
    }
    return true;
  });
  return {
    items
  };
}
export const getOnboardingTranslationKey = (objId, keyType) => {
  switch (objId) {
    case '0-1':
      return keyType === 'header' ? `nav.objCreate.onboarding.contact.header` : `nav.objCreate.onboarding.new.contact.body`;
    case '0-2':
      return keyType === 'header' ? `nav.objCreate.onboarding.company.header` : `nav.objCreate.onboarding.new.company.body`;
    case '0-3':
      return keyType === 'header' ? `nav.objCreate.onboarding.deal.header` : `nav.objCreate.onboarding.new.deal.body`;
    case '0-5':
      return keyType === 'header' ? `nav.objCreate.onboarding.ticket.header` : `nav.objCreate.onboarding.new.ticket.body`;
    case '0-27':
      return keyType === 'header' ? `nav.objCreate.onboarding.task.header` : `nav.objCreate.onboarding.new.task.body`;
    default:
      throw new Error(`Unhandled object ID: ${objId}`);
  }
};